import React from 'react';
import Label from 'components/form/Label/Label';
import { CSTooltip } from 'components/Tooltip/CSToolTip';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { ReactComponent as LockIcon } from 'style/_assets/icons/lock-white.svg';
import { Button } from 'components/form/Button/index';
import { Row } from 'components/Containers/Row/Row';
import { ReactComponent as ResolveLogo } from 'style/icons/resolve-logo.svg';
import { Bullet, BulletList } from 'components/BulletList';
import './DebtReliefOffer.scss';
import { getImageBasePath } from 'helpers/env';
import { CREDIT_CARD_VERTICAL } from 'types/marketplaceTiles.constants';
import OText from 'components/CText/OText';
import { Image } from 'components/Image/Image';
import { useConfig } from 'hook/config.hook';

const bullets = [
  'Free consultation & no upfront fees',
  'A + BBB Rating',
  'Resolve your debt in 12 - 48 months',
];

const getLogoClass = provider => {
  switch (provider) {
    case 'ClearOne':
      return 'clearOne';
    case 'Freedom Debt Relief':
      return 'freedomDebtRelief';
    default:
      return '';
  }
};

const ResolveDebtReliefOffer = props => {
  const amount =
    props.creditInfo.debtAnalysis.creditCardDebt.totalDebt +
    props.creditInfo.debtAnalysis.otherLoanDebt.totalDebt;
  let finalValue = '';

  if (amount > 1000) {
    finalValue = `\\$${Math.round(amount / 1000)}K`;
  } else {
    finalValue = `~\\$1K`;
  }

  return (
    <Row
      datatestid={props.datatestid}
      className="offerCardRow debtReliefOffer grayShadow"
    >
      <FlexContainer className="flex-row">
        <div className="mobileHide format50">
          <img
            alt="resolve art desktop"
            className="desktopResolve"
            src={`${getImageBasePath()}images/art-resolve-var-2.png`}
          />
        </div>
        <FlexContainer className="flex-column m-format100 format50">
          <div className="text-24 fontGray400 bold m-text-22 padtb6 m-text-center">
            Reduce your {finalValue} debt by up to 50%
          </div>
          <div className="text-20 m-text-16 fontGray400 margb-12 padtb6 m-text-center">
            100% online and takes just a few minutes
          </div>
          <div className="desktopHide">
            <img
              alt="resolve art"
              className="format100"
              src={`${getImageBasePath()}images/art-resolve-var-2.png`}
            />
          </div>
          <div className="format100 ">
            <div className="m-format100 format50 inblock">
              <Button
                onClick={props.clickApplyHandler}
                className="format100"
                mrphType="primary"
              >
                See Options Now
              </Button>
            </div>
            <div className="m-format100 format50 inblock text-center resolveLogo">
              <span className="text-12 bold fontGray400">Powered By</span>
              <span>
                <ResolveLogo />
              </span>
            </div>
          </div>
          <div className="fontGray400 text-12 padt24">
            By clicking "See Options Now", you are authorizing Credit Sesame to
            share your personal information, including your credit profile, with
            Resolve for personalized debt solutions. Resolve may also use this
            information for targeted marketing efforts, including contacting you
            by phone or email.
          </div>
        </FlexContainer>
      </FlexContainer>
    </Row>
  );
};

const StandardDebtReliefOffer = props => {
  const offerHeader = `${props.provider} can help you pay down your unsecured debt. Apply today.`;
  const partnerLogoClass = getLogoClass(props.provider);
  const { config } = useConfig();

  return (
    <Row
      datatestid={props.datatestid}
      className="offerCardRow debtReliefOffer grayShadow"
    >
      <FlexContainer className="flex-tablet-col">
        <div className="debtReliefArt format33 m-format100"></div>
        <div className="offerDetailsContainer padL32 padR32 m-killPad m-format100">
          <Label
            type="H5"
            typeHeader={'h5'}
            className="offerHeader margB8 disclaimerContainer"
          >
            {offerHeader}
            <CSTooltip
              vertical={CREDIT_CARD_VERTICAL}
              title={config?.actions?.debt_relief?.tooltip}
              style={{ float: 'left' }}
              isInline
              datatestid={`debtReliefOffer`}
              tooltipName={'Debt Relief'}
              pagePosition={'Debt Relief Module'}
            />
          </Label>
          <Label className="justify-start">
            Start with a free phone consultation for debt assessment.
          </Label>
          <Button
            mrphType="primary"
            className="margT24 margB12 standardDebtOffer"
            onClick={props.clickApplyHandler}
          >
            <LockIcon
              className="lockIcon"
              style={{
                position: 'relative',
                top: -1,
              }}
            />
            Apply Now
          </Button>
          <Label type="caption" className="fontGray300 mtext-center">
            on {props.provider}’s {config?.secureWebsiteDisclaimer}
          </Label>
        </div>
        <div
          className={`partnerLogo ${partnerLogoClass} format25 m-format100`}
        ></div>
      </FlexContainer>
    </Row>
  );
};

const AdrDebtReliefOffer = props => {
  return (
    <FlexContainer className="flex-column">
      <Label
        type="subTitle4 letterSpacing06 text-weight-800 fontLato"
        typeHeader={'h4'}
        className={'margB10 margT16'}
      >
        SPONSORED
      </Label>
      <FlexContainer
        className={`pad16 m-padLR16 m-padTB30 grayShadow16 border-rad8px bgWhite borderYellow3`}
      >
        <FlexContainer className="flex-column justify-around items-align-center width100 m-flex-column gap-5">
          <FlexContainer
            className={`t-flex-column t-flex-align-center items-align-center width100 justify-around`}
          >
            <FlexContainer
              className={`justify-between imageContainer flex-row margR24 m-margr0 m-format100`}
            >
              <FlexContainer className="imageInner">
                <Image className={'debtReliefAdr'} />
              </FlexContainer>
              <FlexContainer className={'width160px align-items-center d-hide'}>
                <Button
                  mrphType="primary"
                  rounded
                  onClick={props.clickApplyHandler}
                  className={'m-borderNone padTB10'}
                >
                  <FlexContainer className="justify-center align-items-center">
                    <Label type="Subtitle-2 primary_cta_text_light">
                      {'Learn more'}
                    </Label>
                  </FlexContainer>
                </Button>
              </FlexContainer>
            </FlexContainer>
            <FlexContainer className="flex-column textContainer margR24 m-margr0 width360px m-format100 m-margT10">
              <Label
                type="Subtitle-1"
                className="offerHeader fontBlue100 margB8 disclaimerContainer"
              >
                {'Accredited Debt Relief'}
              </Label>
              <BulletList className="m-lineHeight-1-4 ">
                {bullets.map((item, index) => {
                  return (
                    <Bullet
                      key={'bullet' + index}
                      className="text-12 margT4 block"
                    >
                      <OText text={item} />
                    </Bullet>
                  );
                })}
              </BulletList>
            </FlexContainer>
            <FlexContainer className={`buttonContainer flex-column t-Width100`}>
              <Button
                mrphType="primary"
                rounded
                onClick={props.clickApplyHandler}
                className={'m-borderNone width160px m-hide padTB10'}
              >
                <FlexContainer className="justify-center align-items-center">
                  <Label type="Subtitle-2 primary_cta_text_light">
                    {'Learn more'}
                  </Label>
                </FlexContainer>
              </Button>
            </FlexContainer>
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

const DebtReliefOffer = props => {
  if (props.provider === 'Resolve') {
    return <ResolveDebtReliefOffer {...props} />;
  } else if (props.provider === 'ADR') {
    return <AdrDebtReliefOffer {...props} />;
  } else {
    return <StandardDebtReliefOffer {...props} />;
  }
};

export default DebtReliefOffer;
